module.exports = __webpack_public_path__ + "static/img/preview.72525739.png";